/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AuthorityUser } from './authorityUser';
import { Comune } from './comune';
import { UserType } from './userType';

export interface GetUserProfileDTO { 
    id?: string;
    email?: string;
    nome?: string;
    cognome?: string;
    fullname?: string;
    authorities?: Array<AuthorityUser>;
    user_type?: UserType;
    account_enabled?: boolean;
    account_activated?: boolean;
    comuni_gestiti?: Array<Comune>;
}